<template>
<div>
	<div v-if="data.impairedRegime" :style="{ 'background' : '#ffffff' }" class="outer flex-col">
        <div class="menu-top flex-row">
            <div @click="$emit( 'update:data', { impairedRegime : false } )" class="menu-look flex-row">
                <svg style="margin-top: 8px;" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 0.54541C4.36364 0.54541 1.23636 2.79996 0 5.99996C1.23636 9.19995 4.36364 11.4545 8 11.4545C11.6364 11.4545 14.7636 9.19995 16 5.99996C14.7636 2.79996 11.6364 0.54541 8 0.54541ZM8 9.63632C5.96364 9.63632 4.36364 8.03632 4.36364 5.99996C4.36364 3.96359 5.96364 2.36359 8 2.36359C10.0364 2.36359 11.6364 3.96359 11.6364 5.99996C11.6364 8.03632 10.0364 9.63632 8 9.63632ZM8 3.81814C6.76364 3.81814 5.81818 4.76359 5.81818 5.99996C5.81818 7.23632 6.76364 8.18177 8 8.18177C9.23636 8.18177 10.1818 7.23632 10.1818 5.99996C10.1818 4.76359 9.23636 3.81814 8 3.81814Z" fill="#000000"/>
                </svg>
				<span v-if="lang === 'ru'">Выключить режим для слабовидящих</span>
				<span v-if="lang === 'kk'">Нашар көретіндерге арналған режимді өшіру</span>
            </div>
            <div :style="{ 'color' : '#000000' }" class="menu-lang flex-row">
                <span @click="changeLang('ru')" v-bind:class="{ imp: lang === 'ru' }">Рус</span>
                <span @click="changeLang('kk')" v-bind:class="{ imp: lang === 'kk' }">Қаз</span>
            </div>
        </div>
        <div class="menu-bottom flex-row">
            <div @click="$router.push({ name: 'home' })" class="icon flex-row">
                <img :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" data-src="/media/logo.png" alt="" class="lazyload"> 
            </div>  
            <div v-show="!onSearch" :style="{ 'color' : '#000000' }" class="list flex-row">
                <div class="top-menu-item impr dropdown">
                    <span v-if="lang === 'ru'" class="dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Рубрики
                    </span>
					<span v-if="lang === 'kk'" class="dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Айдарлар
                    </span>
                    <ul :style="{ 'color' : '#000000', 'background' : '#ffffff' }" class="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                        <li class="dropdown-submenu">
                            <a v-if="lang === 'ru'" class="dropdown-item impr" tabindex="-1">Для Девочек</a>
							<a v-if="lang === 'kk'" class="dropdown-item impr" tabindex="-1">Қыздарға арналған</a>
                            <div class="dropdown-menu flex-row">
                                <div class="sep-line">
                                    <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 15L21 0.277569L21 29.7224L0 15Z" fill="#ffffff"/>
                                    </svg>
                                </div>
                                <ul class="impr in">  
                                    <li v-if="lang === 'ru'"  @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })" class="dropdown-item"><a class="impr" tabindex="-1">Мое тело</a></li>
									<li v-if="lang === 'kk'"  @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })" class="dropdown-item"><a class="impr" tabindex="-1">Менің тәнім</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'transitional-age' } })" class="dropdown-item"><a class="impr">Переходный возраст</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'transitional-age' } })" class="dropdown-item"><a class="impr">Өтпелі кезең</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'STD' } })" class="dropdown-item"><a class="impr">Инфекция (ИППП)</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'STD' } })" class="dropdown-item"><a class="impr">Инфекция (ЖЖБИ)</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'contraception' } })" class="dropdown-item"><a class="impr">Контрацепция</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'contraception' } })" class="dropdown-item"><a class="impr">Контрацепция</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'me-others' } })" class="dropdown-item"><a class="impr">Я и другие</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'me-others' } })" class="dropdown-item"><a class="impr">Мен және басқалар</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="dropdown-submenu">
                            <a v-if="lang === 'ru'" class="dropdown-item impr" tabindex="-1">Для Мальчишек</a>
							<a v-if="lang === 'kk'" class="dropdown-item impr" tabindex="-1">Ер балаларға арналған</a>
                            <div class="dropdown-menu flex-row">
                                <div class="sep-line">
                                    <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 15L21 0.277569L21 29.7224L0 15Z" fill="#ffffff"/>
                                    </svg>
                                </div>
                                <ul class="impr in">  
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'mybody' } })" class="dropdown-item"><a class="impr" tabindex="-1">Мое тело</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'mybody' } })" class="dropdown-item"><a class="impr" tabindex="-1">Менің тәнім</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'transitional-age' } })" class="dropdown-item"><a class="impr">Переходный возраст</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'transitional-age' } })" class="dropdown-item"><a class="impr">Өтпелі кезең</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'STD' } })" class="dropdown-item"><a class="impr">Инфекция (ИППП)</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'STD' } })" class="dropdown-item"><a class="impr">Инфекция (ЖЖБИ)</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'contraception' } })" class="dropdown-item"><a class="impr">Контрацепция</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'contraception' } })" class="dropdown-item"><a class="impr">Контрацепция</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'me-others' } })" class="dropdown-item"><a class="impr">Я и другие</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'me-others' } })" class="dropdown-item"><a class="impr">Мен және басқалар</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="dropdown-submenu">
                            <a v-if="lang === 'ru'" class="dropdown-item impr" tabindex="-1">Для родителей</a>
							<a v-if="lang === 'kk'" class="dropdown-item impr" tabindex="-1">Ата-аналарға арналған</a>
                            <div class="dropdown-menu flex-row">
                                <div class="sep-line">
                                    <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 15L21 0.277569L21 29.7224L0 15Z" fill="#ffffff"/>
                                    </svg>
                                </div>
                                <ul class="impr in">  
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'important-for-parents' } })" class="dropdown-item"><a class="impr" tabindex="-1">Что важно знать родителям</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'important-for-parents' } })" class="dropdown-item"><a class="impr" tabindex="-1">Ата-аналарға арналған маңызды</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'about-complicated' } })" class="dropdown-item"><a class="impr">Просто о сложном</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'about-complicated' } })" class="dropdown-item"><a class="impr">Күрделі жағдай туралы қарапайым тілмен баяндау</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'healthy-generation' } })" class="dropdown-item"><a class="impr">Здоровое поколение</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'healthy-generation' } })" class="dropdown-item"><a class="impr">Дені сау ұрпақ</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="dropdown-submenu">
                            <a v-if="lang === 'ru'" class="dropdown-item impr" tabindex="-1">Парням и девушкам</a>
							<a v-if="lang === 'kk'" class="dropdown-item impr" tabindex="-1">Бозбалалар мен бойжеткендерге арналған</a>
                            <div class="dropdown-menu flex-row">
                                <div class="sep-line">
                                    <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 15L21 0.277569L21 29.7224L0 15Z" fill="#ffffff"/>
                                    </svg>
                                </div>
                                <ul class="impr in">  
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'about-body-health' } })" class="dropdown-item"><a class="impr" tabindex="-1">О теле и его здоровье</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'about-body-health' } })" class="dropdown-item"><a class="impr" tabindex="-1">Тән және денсаулық туралы</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'important-years' } })" class="dropdown-item"><a class="impr">Важные годы</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'important-years' } })" class="dropdown-item"><a class="impr">Маңызды уақыт</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'me-others' } })" class="dropdown-item"><a class="impr">Я и Другие</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'me-others' } })" class="dropdown-item"><a class="impr">Мен және басқалар</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'STD' } })" class="dropdown-item"><a class="impr">Инфекция (ИППП)</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'STD' } })" class="dropdown-item"><a class="impr">Инфекция (ЖЖБИ)</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'contraception' } })" class="dropdown-item"><a class="impr">Контрацепция</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'contraception' } })" class="dropdown-item"><a class="impr">Контрацепция</a></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="lang === 'ru'" class="top-menu-item impr" @click="$router.push({ name: 'about' })" v-bind:class="{ active: $route.name === 'about' }">О проекте</div>
				<div v-if="lang === 'kk'" class="top-menu-item impr" @click="$router.push({ name: 'about' })" v-bind:class="{ active: $route.name === 'about' }">Жоба туралы</div>
                <div v-if="lang === 'ru'" class="top-menu-item impr" @click="$router.push({ name: 'faq' })" v-bind:class="{ active: $route.name === 'faq' }">Вопросы и ответы</div>
				<div v-if="lang === 'kk'" class="top-menu-item impr" @click="$router.push({ name: 'faq' })" v-bind:class="{ active: $route.name === 'faq' }">Сұрақ-жауап</div>
                <div v-if="lang === 'ru'" class="top-menu-item impr" @click="$router.push({ name: 'news' })" v-bind:class="{ active: $route.name === 'news' }">Новости</div>
				<div v-if="lang === 'kk'" class="top-menu-item impr" @click="$router.push({ name: 'news' })" v-bind:class="{ active: $route.name === 'news' }">Жаңалықтар</div>
                <div v-if="lang === 'ru'" class="top-menu-item impr" @click="$router.push({ name: 'location' })" v-bind:class="{ active: $route.name === 'location' }">МЦЗ</div>
				<div v-if="lang === 'kk'" class="top-menu-item impr" @click="$router.push({ name: 'location' })" v-bind:class="{ active: $route.name === 'location' }">Жастар Денсаулық Орталықтары</div>
                <div v-if="lang === 'ru'" class="top-menu-item impr" @click="$router.push({ name: 'contact' })" v-bind:class="{ active: $route.name === 'contact' }">Контакты</div>
				<div v-if="lang === 'kk'" class="top-menu-item impr" @click="$router.push({ name: 'contact' })" v-bind:class="{ active: $route.name === 'contact' }">Байланыс</div>
            </div>
            <div class="search">
                <div class="search-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#000000"/>
                    </svg>
                </div>
                <input v-if="lang === 'ru'" v-click-outside="onClickOutside" v-on:keyup.enter="$router.push({ name: 'search', query: { text: search_text } })" v-model="search_text" @click="onSearch = true" :style="{'border' : '1px solid #000000'}" v-bind:class="{ off: !onSearch, on: onSearch }" type="text" placeholder="Поиск...">
				<input v-if="lang === 'kk'" v-click-outside="onClickOutside" v-on:keyup.enter="$router.push({ name: 'search', query: { text: search_text } })" v-model="search_text" @click="onSearch = true" :style="{'border' : '1px solid #000000'}" v-bind:class="{ off: !onSearch, on: onSearch }" type="text" placeholder="Іздеу...">
                <div v-show="onSearch" @click="onSearch = false; search_text = ''" class="clear-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 1.8L16.2 0L9 7.2L1.8 0L0 1.8L7.2 9L0 16.2L1.8 18L9 10.8L16.2 18L18 16.2L10.8 9L18 1.8Z" fill="#000000"/>
                    </svg>
                </div>
            </div>
        </div>
		<div class="menu-mobile">
			<div @click="sideMenu = !sideMenu" class="menu-icon">
				<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0 16H24V13.3333H0V16ZM0 9.33333H24V6.66667H0V9.33333ZM0 0V2.66667H24V0H0Z" fill="#000000"/>
				</svg>
			</div>
			<div @click="$router.push({ name: 'home' })" v-bind:class="{ invisible: onSearchMobile }" class="logo">
				<img :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" data-src="/media/footer-logo.png" alt="" class="lazyload">
			</div>
			<div :style="{ 'color' : '#000000' }" class="menu-lang flex-row">
                <span @click="changeLang('ru')" v-bind:class="{ imp: lang === 'ru' }">Рус</span>
                <span @click="changeLang('kk')" v-bind:class="{ imp: lang === 'kk' }">Қаз</span>
            </div>
			<div v-if="!onSearchMobile" @click="$emit( 'update:data', { impairedRegime : false } )" class="menu-impaired">
				<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 0.818359C6.54545 0.818359 1.85455 4.20018 0 9.00018C1.85455 13.8002 6.54545 17.182 12 17.182C17.4545 17.182 22.1455 13.8002 24 9.00018C22.1455 4.20018 17.4545 0.818359 12 0.818359ZM12 14.4547C8.94545 14.4547 6.54545 12.0547 6.54545 9.00018C6.54545 5.94563 8.94545 3.54563 12 3.54563C15.0545 3.54563 17.4545 5.94563 17.4545 9.00018C17.4545 12.0547 15.0545 14.4547 12 14.4547ZM12 5.72745C10.1455 5.72745 8.72727 7.14563 8.72727 9.00018C8.72727 10.8547 10.1455 12.2729 12 12.2729C13.8545 12.2729 15.2727 10.8547 15.2727 9.00018C15.2727 7.14563 13.8545 5.72745 12 5.72745Z" fill="#000000"/>
				</svg>
			</div>
			<div v-if="!onSearchMobile" @click="onSearchMobile = true" class="menu-search">
				<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M13.0628 11.3474C15.0673 8.51725 14.8226 4.5794 12.2991 2.04135C9.59336 -0.679926 4.81417 -0.680973 2.1122 2.04135C-0.704788 4.87203 -0.703347 9.45754 2.1122 12.2868C4.63607 14.8272 8.55239 15.0695 11.365 13.0549L13.0628 11.3474Z" fill="#000000"/>
					<path d="M12.4 7.2C12.4 10.0719 10.0719 12.4 7.2 12.4C4.32812 12.4 2 10.0719 2 7.2C2 4.32812 4.32812 2 7.2 2C10.0719 2 12.4 4.32812 12.4 7.2Z" fill="#ffffff"/>
					<path d="M13.2178 12.3355H14.1994L20.4 18.5485L18.5485 20.4L12.3355 14.1994V13.2178L12 12.8698L12.8698 12L13.2178 12.3355Z" fill="#000000"/>
				</svg>
			</div>
			<div v-if="onSearchMobile" class="search">
                <div class="search-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#568357"/>
                    </svg>
                </div>
                <input v-if="lang === 'ru'" v-click-outside="onClickOutsideMobile" v-on:keyup.enter="$router.push({ name: 'search', query: { text: search_text } })" v-model="search_text" @click="onSearchMobile = true" :style="{'border' : '1px solid #f2f2f2'}" v-bind:class="{ off: !onSearchMobile, on: onSearchMobile }" type="text" placeholder="Поиск...">
				<input v-if="lang === 'kk'" v-click-outside="onClickOutsideMobile" v-on:keyup.enter="$router.push({ name: 'search', query: { text: search_text } })" v-model="search_text" @click="onSearchMobile = true" :style="{'border' : '1px solid #f2f2f2'}" v-bind:class="{ off: !onSearchMobile, on: onSearchMobile }" type="text" placeholder="Іздеу...">
                <div v-show="onSearchMobile" @click="onSearchMobile = false; search_text = ''" class="clear-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 1.8L16.2 0L9 7.2L1.8 0L0 1.8L7.2 9L0 16.2L1.8 18L9 10.8L16.2 18L18 16.2L10.8 9L18 1.8Z" fill="#568357"/>
                    </svg>
                </div>
            </div>
		</div>
		<div v-if="sideMenu" :style="{ 'background' : '#000000' }" class="menu-side flex-col">
			<div @click="sideMenu = false" class="close-icon">
				<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M9.93359 1.86667L3.80021 8L9.93359 14.1333L8.06688 16L0.066927 8L8.06688 0L9.93359 1.86667Z" fill="white"/>
				</svg>
			</div>
			<div v-if="lang === 'ru'" @click="sideMenu = false" class="list flex-col">
				<div class="item" @click="$router.push({ name: 'rubric' })" v-bind:class="{ active: $route.name === 'rubric' }">Рубрики</div>
				<div class="item" @click="$router.push({ name: 'about' })" v-bind:class="{ active: $route.name === 'about' }">О проекте</div>
				<div class="item" @click="$router.push({ name: 'faq' })" v-bind:class="{ active: $route.name === 'faq' }">Вопросы и ответы</div>
				<div class="item" @click="$router.push({ name: 'news' })" v-bind:class="{ active: $route.name === 'news' }">Новости</div>
				<div class="item" @click="$router.push({ name: 'location' })" v-bind:class="{ active: $route.name === 'location' }">МЦЗ</div>
				<div class="item" @click="$router.push({ name: 'contact' })" v-bind:class="{ active: $route.name === 'contact' }">Контакты</div>
			</div>
			<div v-if="lang === 'kk'" @click="sideMenu = false" class="list flex-col">
				<div class="item" @click="$router.push({ name: 'rubric' })" v-bind:class="{ active: $route.name === 'rubric' }">Айдарлар</div>
				<div class="item" @click="$router.push({ name: 'about' })" v-bind:class="{ active: $route.name === 'about' }">Жоба жайлы</div>
				<div class="item" @click="$router.push({ name: 'faq' })" v-bind:class="{ active: $route.name === 'faq' }">Сұрақтар мен жауаптар</div>
				<div class="item" @click="$router.push({ name: 'news' })" v-bind:class="{ active: $route.name === 'news' }">Жаңалықтар</div>
				<div class="item" @click="$router.push({ name: 'location' })" v-bind:class="{ active: $route.name === 'location' }">Жастар Денсаулық Орталықтары</div>
				<div class="item" @click="$router.push({ name: 'contact' })" v-bind:class="{ active: $route.name === 'contact' }">Байланыстар</div>
			</div>
			<a class="phone">+7 727 3 78 88 89</a>
			<a class="mail">hello.company@company.kz</a>
		</div>
    </div>
	<div v-else :style="{ 'background' : '#f2f2f2' }" class="outer flex-col">
        <div class="menu-top flex-row">
            <div @click="$emit( 'update:data', { impairedRegime : true } )" class="menu-look flex-row">
                <svg style="margin-top: 8px;" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 0.54541C4.36364 0.54541 1.23636 2.79996 0 5.99996C1.23636 9.19995 4.36364 11.4545 8 11.4545C11.6364 11.4545 14.7636 9.19995 16 5.99996C14.7636 2.79996 11.6364 0.54541 8 0.54541ZM8 9.63632C5.96364 9.63632 4.36364 8.03632 4.36364 5.99996C4.36364 3.96359 5.96364 2.36359 8 2.36359C10.0364 2.36359 11.6364 3.96359 11.6364 5.99996C11.6364 8.03632 10.0364 9.63632 8 9.63632ZM8 3.81814C6.76364 3.81814 5.81818 4.76359 5.81818 5.99996C5.81818 7.23632 6.76364 8.18177 8 8.18177C9.23636 8.18177 10.1818 7.23632 10.1818 5.99996C10.1818 4.76359 9.23636 3.81814 8 3.81814Z" fill="#4B5F4C"/>
                </svg>
				<span v-if="lang === 'ru'">Включить режим для слабовидящих</span>
				<span v-if="lang === 'kk'">Нашар көретіндерге арналған режимді қосу</span>
            </div>
            <div :style="{ 'color' : '#333333' }" class="menu-lang flex-row">
                <span @click="changeLang('ru')" v-bind:class="{ active: lang === 'ru' }">Рус</span>
                <span @click="changeLang('kk')" v-bind:class="{ active: lang === 'kk' }">Қаз</span>
            </div>
        </div>
        <div class="menu-bottom flex-row">
            <div @click="$router.push({ name: 'home' })" class="icon flex-row">
                <img data-src="/media/logo.png" alt="" class="lazyload">
            </div>  
            <div v-show="!onSearch" :style="{ 'color' : '#568357'}" class="list flex-row">
                <div class="top-menu-item dropdown">
                    <span v-if="lang === 'ru'" class="dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Рубрики
                    </span>
					<span v-if="lang === 'kk'" class="dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Айдарлар
                    </span>
                    <ul :style="{ 'color' : '#F6F4EB', 'background' : '#336034' }" class="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                        <li class="dropdown-submenu">
                            <a v-if="lang === 'ru'" class="dropdown-item" tabindex="-1">Для Девочек</a>
							<a v-if="lang === 'kk'" class="dropdown-item" tabindex="-1">Қыздарға арналған</a>
                            <div class="dropdown-menu flex-row">
                                <div class="sep-line">
                                    <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 15L21 0.277569L21 29.7224L0 15Z" fill="#568357"/>
                                    </svg>
                                </div>
                                <ul class="in">  
                                    <li v-if="lang === 'ru'"  @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })" class="dropdown-item"><a tabindex="-1">Мое тело</a></li>
									<li v-if="lang === 'kk'"  @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })" class="dropdown-item"><a tabindex="-1">Менің тәнім</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'transitional-age' } })" class="dropdown-item"><a>Переходный возраст</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'transitional-age' } })" class="dropdown-item"><a>Өтпелі кезең</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'STD' } })" class="dropdown-item"><a>Инфекция (ИППП)</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'STD' } })" class="dropdown-item"><a>Инфекция (ЖЖБИ)</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'contraception' } })" class="dropdown-item"><a>Контрацепция</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'contraception' } })" class="dropdown-item"><a>Контрацепция</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'me-others' } })" class="dropdown-item"><a>Я и другие</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'me-others' } })" class="dropdown-item"><a>Мен және басқалар</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="dropdown-submenu">
                            <a v-if="lang === 'ru'" class="dropdown-item" tabindex="-1">Для Мальчишек</a>
							<a v-if="lang === 'kk'" class="dropdown-item" tabindex="-1">Ер балаларға арналған</a>
                            <div class="dropdown-menu flex-row">
                                <div class="sep-line">
                                    <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 15L21 0.277569L21 29.7224L0 15Z" fill="#568357"/>
                                    </svg>
                                </div>
                                <ul class="in">  
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'mybody' } })" class="dropdown-item"><a tabindex="-1">Мое тело</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'mybody' } })" class="dropdown-item"><a tabindex="-1">Менің тәнім</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'transitional-age' } })" class="dropdown-item"><a>Переходный возраст</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'transitional-age' } })" class="dropdown-item"><a>Өтпелі кезең</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'STD' } })" class="dropdown-item"><a>Инфекция (ИППП)</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'STD' } })" class="dropdown-item"><a>Инфекция (ЖЖБИ)</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'contraception' } })" class="dropdown-item"><a>Контрацепция</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'contraception' } })" class="dropdown-item"><a>Контрацепция</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'me-others' } })" class="dropdown-item"><a>Я и другие</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'boys', sub: 'me-others' } })" class="dropdown-item"><a>Мен және басқалар</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="dropdown-submenu">
                            <a v-if="lang === 'ru'" class="dropdown-item" tabindex="-1">Для родителей</a>
							<a v-if="lang === 'kk'" class="dropdown-item" tabindex="-1">Ата-аналарға арналған</a>
                            <div class="dropdown-menu flex-row">
                                <div class="sep-line">
                                    <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 15L21 0.277569L21 29.7224L0 15Z" fill="#568357"/>
                                    </svg>
                                </div>
                                <ul class="in">  
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'important-for-parents' } })" class="dropdown-item"><a tabindex="-1">Что важно знать родителям</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'important-for-parents' } })" class="dropdown-item"><a tabindex="-1">Ата-аналарға арналған маңызды</a></li>
									<li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'about-complicated' } })" class="dropdown-item"><a>Просто о сложном</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'about-complicated' } })" class="dropdown-item"><a>Күрделі жағдай туралы қарапайым тілмен баяндау</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'healthy-generation' } })" class="dropdown-item"><a>Здоровое поколение</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'parents', sub: 'healthy-generation' } })" class="dropdown-item"><a>Дені сау ұрпақ</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="dropdown-submenu">
                            <a v-if="lang === 'ru'" class="dropdown-item" tabindex="-1">Парням и девушкам</a>
							<a v-if="lang === 'kk'" class="dropdown-item" tabindex="-1">Бозбалалар мен бойжеткендерге арналған</a>
                            <div class="dropdown-menu flex-row">
                                <div class="sep-line">
                                    <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 15L21 0.277569L21 29.7224L0 15Z" fill="#568357"/>
                                    </svg>
                                </div>
                                <ul class="in">  
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'about-body-health' } })" class="dropdown-item"><a tabindex="-1">О теле и его здоровье</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'about-body-health' } })" class="dropdown-item"><a tabindex="-1">Тән және денсаулық туралы</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'important-years' } })" class="dropdown-item"><a>Важные годы</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'important-years' } })" class="dropdown-item"><a>Маңызды уақыт</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'me-others' } })" class="dropdown-item"><a>Я и Другие</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'me-others' } })" class="dropdown-item"><a>Мен және басқалар</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'STD' } })" class="dropdown-item"><a>Инфекция (ИППП)</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'STD' } })" class="dropdown-item"><a>Инфекция (ЖЖБИ)</a></li>
                                    <li v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'contraception' } })" class="dropdown-item"><a>Контрацепция</a></li>
									<li v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'both', sub: 'contraception' } })" class="dropdown-item"><a>Контрацепция</a></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="lang === 'ru'" class="top-menu-item" @click="$router.push({ name: 'about' })" v-bind:class="{ active: $route.name === 'about' }">О проекте</div>
				<div v-if="lang === 'kk'" class="top-menu-item" @click="$router.push({ name: 'about' })" v-bind:class="{ active: $route.name === 'about' }">Жоба туралы</div>
                <div v-if="lang === 'ru'" class="top-menu-item" @click="$router.push({ name: 'faq' })" v-bind:class="{ active: $route.name === 'faq' }">Вопросы и ответы</div>
				<div v-if="lang === 'kk'" class="top-menu-item" @click="$router.push({ name: 'faq' })" v-bind:class="{ active: $route.name === 'faq' }">Сұрақ-жауап</div>
                <div v-if="lang === 'ru'" class="top-menu-item" @click="$router.push({ name: 'news' })" v-bind:class="{ active: $route.name === 'news' }">Новости</div>
				<div v-if="lang === 'kk'" class="top-menu-item" @click="$router.push({ name: 'news' })" v-bind:class="{ active: $route.name === 'news' }">Жаңалықтар</div>
                <div v-if="lang === 'ru'" class="top-menu-item" @click="$router.push({ name: 'location' })" v-bind:class="{ active: $route.name === 'location' }">МЦЗ</div>
				<div v-if="lang === 'kk'" class="top-menu-item" @click="$router.push({ name: 'location' })" v-bind:class="{ active: $route.name === 'location' }">Жастар Денсаулық Орталықтары</div>
                <div v-if="lang === 'ru'" class="top-menu-item" @click="$router.push({ name: 'contact' })" v-bind:class="{ active: $route.name === 'contact' }">Контакты</div>
				<div v-if="lang === 'kk'" class="top-menu-item" @click="$router.push({ name: 'contact' })" v-bind:class="{ active: $route.name === 'contact' }">Байланыс</div>
            </div>
            <div class="search">
                <div class="search-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#568357"/>
                    </svg>
                </div>
                <input v-if="lang === 'ru'" v-click-outside="onClickOutside" v-on:keyup.enter="$router.push({ name: 'search', query: { text: search_text } })" v-model="search_text" @click="onSearch = true" :style="{'border' : '1px solid #f2f2f2'}" v-bind:class="{ off: !onSearch, on: onSearch }" type="text" placeholder="Поиск...">
				<input v-if="lang === 'kk'" v-click-outside="onClickOutside" v-on:keyup.enter="$router.push({ name: 'search', query: { text: search_text } })" v-model="search_text" @click="onSearch = true" :style="{'border' : '1px solid #f2f2f2'}" v-bind:class="{ off: !onSearch, on: onSearch }" type="text" placeholder="Іздеу...">
                <div v-show="onSearch" @click="onSearch = false; search_text = ''" class="clear-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 1.8L16.2 0L9 7.2L1.8 0L0 1.8L7.2 9L0 16.2L1.8 18L9 10.8L16.2 18L18 16.2L10.8 9L18 1.8Z" fill="#568357"/>
                    </svg>
                </div>
            </div>
        </div>
		<div class="menu-mobile">
			<div @click="sideMenu = !sideMenu" class="menu-icon">
				<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0 16H24V13.3333H0V16ZM0 9.33333H24V6.66667H0V9.33333ZM0 0V2.66667H24V0H0Z" fill="#568357"/>
				</svg>
			</div>
			<div @click="$router.push({ name: 'home' })" v-bind:class="{ invisible: onSearchMobile }" class="logo">
				<img data-src="/media/footer-logo.png" alt="" class="lazyload">
			</div>
			<div class="menu-lang flex-row">
                <span @click="changeLang('ru')" v-bind:class="{ imp: lang === 'ru' }">Рус</span>
                <span @click="changeLang('kk')" v-bind:class="{ imp: lang === 'kk' }">Қаз</span>
            </div>
			<div v-if="!onSearchMobile" @click="$emit( 'update:data', { impairedRegime : true } )" class="menu-impaired">
				<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 0.818359C6.54545 0.818359 1.85455 4.20018 0 9.00018C1.85455 13.8002 6.54545 17.182 12 17.182C17.4545 17.182 22.1455 13.8002 24 9.00018C22.1455 4.20018 17.4545 0.818359 12 0.818359ZM12 14.4547C8.94545 14.4547 6.54545 12.0547 6.54545 9.00018C6.54545 5.94563 8.94545 3.54563 12 3.54563C15.0545 3.54563 17.4545 5.94563 17.4545 9.00018C17.4545 12.0547 15.0545 14.4547 12 14.4547ZM12 5.72745C10.1455 5.72745 8.72727 7.14563 8.72727 9.00018C8.72727 10.8547 10.1455 12.2729 12 12.2729C13.8545 12.2729 15.2727 10.8547 15.2727 9.00018C15.2727 7.14563 13.8545 5.72745 12 5.72745Z" fill="#568357"/>
				</svg>
			</div>
			<div v-if="!onSearchMobile" @click="onSearchMobile = true" class="menu-search">
				<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M13.0628 11.3474C15.0673 8.51725 14.8226 4.5794 12.2991 2.04135C9.59336 -0.679926 4.81417 -0.680973 2.1122 2.04135C-0.704788 4.87203 -0.703347 9.45754 2.1122 12.2868C4.63607 14.8272 8.55239 15.0695 11.365 13.0549L13.0628 11.3474Z" fill="#568357"/>
					<path d="M12.4 7.2C12.4 10.0719 10.0719 12.4 7.2 12.4C4.32812 12.4 2 10.0719 2 7.2C2 4.32812 4.32812 2 7.2 2C10.0719 2 12.4 4.32812 12.4 7.2Z" fill="#F2F2F2"/>
					<path d="M13.2178 12.3355H14.1994L20.4 18.5485L18.5485 20.4L12.3355 14.1994V13.2178L12 12.8698L12.8698 12L13.2178 12.3355Z" fill="#568357"/>
				</svg>
			</div>
			<div v-if="onSearchMobile" class="search">
                <div class="search-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#568357"/>
                    </svg>
                </div>
                <input v-if="lang === 'ru'" v-click-outside="onClickOutsideMobile" v-on:keyup.enter="$router.push({ name: 'search', query: { text: search_text } })" v-model="search_text" @click="onSearchMobile = true" :style="{'border' : '1px solid #f2f2f2'}" v-bind:class="{ off: !onSearchMobile, on: onSearchMobile }" type="text" placeholder="Поиск...">
				<input v-if="lang === 'kk'" v-click-outside="onClickOutsideMobile" v-on:keyup.enter="$router.push({ name: 'search', query: { text: search_text } })" v-model="search_text" @click="onSearchMobile = true" :style="{'border' : '1px solid #f2f2f2'}" v-bind:class="{ off: !onSearchMobile, on: onSearchMobile }" type="text" placeholder="Іздеу...">
                <div v-show="onSearchMobile" @click="onSearchMobile = false; search_text = ''" class="clear-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 1.8L16.2 0L9 7.2L1.8 0L0 1.8L7.2 9L0 16.2L1.8 18L9 10.8L16.2 18L18 16.2L10.8 9L18 1.8Z" fill="#568357"/>
                    </svg>
                </div>
            </div>
		</div>
		<div v-if="sideMenu" class="menu-side flex-col">
			<div @click="sideMenu = false" class="close-icon">
				<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M9.93359 1.86667L3.80021 8L9.93359 14.1333L8.06688 16L0.066927 8L8.06688 0L9.93359 1.86667Z" fill="white"/>
				</svg>
			</div>
			<div v-if="lang === 'ru'" @click="sideMenu = false" class="list flex-col">
				<div class="item" @click="$router.push({ name: 'rubric' })" v-bind:class="{ active: $route.name === 'rubric' }">Рубрики</div>
				<div class="item" @click="$router.push({ name: 'about' })" v-bind:class="{ active: $route.name === 'about' }">О проекте</div>
				<div class="item" @click="$router.push({ name: 'faq' })" v-bind:class="{ active: $route.name === 'faq' }">Вопросы и ответы</div>
				<div class="item" @click="$router.push({ name: 'news' })" v-bind:class="{ active: $route.name === 'news' }">Новости</div>
				<div class="item" @click="$router.push({ name: 'location' })" v-bind:class="{ active: $route.name === 'location' }">МЦЗ</div>
				<div class="item" @click="$router.push({ name: 'contact' })" v-bind:class="{ active: $route.name === 'contact' }">Контакты</div>
			</div>
			<div v-if="lang === 'kk'" @click="sideMenu = false" class="list flex-col">
				<div class="item" @click="$router.push({ name: 'rubric' })" v-bind:class="{ active: $route.name === 'rubric' }">Айдарлар</div>
				<div class="item" @click="$router.push({ name: 'about' })" v-bind:class="{ active: $route.name === 'about' }">Жоба жайлы</div>
				<div class="item" @click="$router.push({ name: 'faq' })" v-bind:class="{ active: $route.name === 'faq' }">Сұрақтар мен жауаптар</div>
				<div class="item" @click="$router.push({ name: 'news' })" v-bind:class="{ active: $route.name === 'news' }">Жаңалықтар</div>
				<div class="item" @click="$router.push({ name: 'location' })" v-bind:class="{ active: $route.name === 'location' }">Жастар Денсаулық Орталықтары</div>
				<div class="item" @click="$router.push({ name: 'contact' })" v-bind:class="{ active: $route.name === 'contact' }">Байланыстар</div>
			</div>
			<a class="phone">+7 727 3 78 88 89</a>
			<a class="mail">hello.company@company.kz</a>
		</div>
    </div>
</div>
</template>
<script>
import vClickOutside from 'v-click-outside'
export default {
	props: [ 'data' ],
	directives: {
      clickOutside: vClickOutside.directive
    },
    data(){
        return {
			imageOn: true,
			background: "#FFFFFF",
			fontSize: 18,
			fontColor: "#000000",
			fontOn: 1,
			colorOn: 0,
            lang: 'kk',
			onSearch: false,
			onSearchMobile: false,
			search_text: '',
			sideMenu: false
        }
	},
	created(){
		if( localStorage.getItem('xyzCustomLang') ){
			this.lang = localStorage.getItem('xyzCustomLang')
		}
	},
    methods: {
		onClickOutside () {
			this.onSearch = false
		},
		onClickOutsideMobile () {
			this.onSearchMobile = false
		},
		onEnterSearch(){
			console.log("work")
		},
		changeLang(val){
			this.lang = val
			localStorage.setItem('xyzCustomLang', val)
			this.$router.go()
		}
    }
}
</script>
<style scoped lang="scss">
    .outer{
		position: relative;
        height: 140px;
        padding: 26px 0 24px 0;
		transition: all 0.6s ease;
        .menu-top{
            position: relative;
            height: 28px;
            .menu-look{
                cursor: pointer;
                position: relative;
                left: 16%;
                span{
                    line-height: 28px;
                    margin-left: 8px;
                    font-weight: 500;
                    letter-spacing: 0.04em;
                    color: #333333;
                }
            }
            .menu-lang{
                position: absolute;
                right: 8%;
                span{
                    line-height: 28px;
                    cursor: pointer;
                    margin-left: 21px;
                    font-weight: 500;
                    letter-spacing: 0.04em;
                }
                span.active{
					font-family: Gilroy-Medium;
                    color: #4B5F4C;
                    font-weight: bold;
                }
				span.imp{
					font-family: Gilroy-Medium;
                    font-weight: bold;
                }
            }
        }
        .menu-bottom{
            position: relative;
            .icon{
				left: 5%;
                cursor: pointer;
                position: absolute;
                top: -6px;
                span{
                    height: 32px;
                    width: 32px;
                    border-radius: 50%;
                    border: 2px solid #4B5F4C;
                    box-sizing: border-box;
                }
                .solid{
                    background: #4B5F4C;
                }
                .empty{
                    margin-left: -16px;
                    background: #FFFFFF;
                }
				img{
					filter: gray;
					width: 40%;
					height: auto;
					align-self: flex-start;
				}
            }
            .list{
                position: relative;
                top: 52px;
                left: calc(16% - 6px);
                .top-menu-item{
                    height: 36px;
                    padding: 0 6px 6px 6px;
                    cursor: pointer;
                    margin-right: 28px;
                    text-decoration: none;
                    font-weight: 500;
                    line-height: 28px;
                    letter-spacing: 0.04em;
                }
                .top-menu-item.active{
                    font-weight: bold;
                    border-bottom: 3px solid #568357;
                    border-bottom-left-radius: 3px;
                    border-bottom-right-radius: 3px;
                }
				.top-menu-item.imp{
                    font-weight: bold;
                    border-bottom: 3px solid #000000;
                    border-bottom-left-radius: 3px;
                    border-bottom-right-radius: 3px;
                }
                .top-menu-item:hover{
                    font-weight: bold;
                    border-bottom: 3px solid #568357;
                    border-bottom-left-radius: 3px;
                    border-bottom-right-radius: 3px;
                }
				.top-menu-item.impr:hover{
                    font-weight: bold;
                    border-bottom: 3px solid #000000 !important;
                    border-bottom-left-radius: 3px;
                    border-bottom-right-radius: 3px;
                }
				.top-menu-item:hover>.dropdown-menu {
                    display: block;	
					transform: translate3d(6px, 18px, 0px);
                }
                .dropdown-menu.multi-level{
                    top: 25px !important;
                    left: -10px !important;
                    box-shadow: 5px 8px 50px rgba(16, 112, 177, 0.2);
                    border: none;
                    border-radius: 2px;
                    border-bottom-left-radius: 10px;
                    border-bottom-right-radius: 10px;
                    min-width: 300px;
                    li{
                       background: none;
                    }
                    a{
						color: inherit;
                        text-decoration: none;
                        width: calc(100% - 32px);
                        margin: 0 16px;
                        padding: 12px 0;
                        text-align: left;
                        font-weight: 500;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        border-top: 1px dashed #336034;
                        border-bottom: 1px dashed #336034;
                    }
					a.impr{
						border-top: 1px dashed #ffffff;
                        border-bottom: 1px dashed #ffffff;
					}
                    a:hover{
                        font-weight: 800;
                        background: none;
                        border-top: 1px dashed rgba(255, 255, 255, 0.3);  
                        border-bottom: 1px dashed rgba(255, 255, 255, 0.3);    
                    }   
					a.impr:hover{
						border-top: 1px dashed #000000;
                        border-bottom: 1px dashed #000000;
					}
                }
                .dropdown-submenu {
                    position: relative;
                }
                .dropdown-submenu>.dropdown-menu {
                    top: -10px;
                    left: calc(100%);
                    background: none;
                    border: none;
                    padding: 0 0 0 20px;
					color: inherit;
                    .sep-line{
                        top: 30px;
                        left: -1px;
                        position: absolute;
                        background: none;
                    }
                    ul{
                        padding: 10px 20px;
                        background: #568357;
                        border-radius: 10px;
                    }
					ul.impr{
						background: #ffffff;
					}
                    li{
						color: inherit;
                        padding: 0;
                        margin: 10px 0;
                    }
                    a{
						color: inherit;
                        text-align: left;
                        padding: 8px 0;
                        margin: 0;
                        border-top: none;
                        border-bottom: 1px dashed #568357;
                        font-weight: 500;
                        line-height: 30px;
                    }
					a.impr{
						border-top: none;
						border-bottom: 1px dashed #ffffff;
					}
                    a:hover{
                        font-weight: 800;
                        background: none;
                        border-top: none;
                        border-bottom: 1px dashed rgba(255, 255, 255, 0.3);    
                    } 
					a:focus{
						background: none !important;
					}
					a.impr:hover{
						border-top: none;
						border-bottom: 1px dashed #000000;    
					}
                }

                .dropdown-submenu:hover>.dropdown-menu {
                    display: block;	
                }
                .dropdown-submenu.pull-left {
                    float: none;
                }

                .dropdown-submenu.pull-left>.dropdown-menu {
                    left: -100%;
                    margin-left: 10px;
                    -webkit-border-radius: 6px 0 6px 6px;
                    -moz-border-radius: 6px 0 6px 6px;
                    border-radius: 6px 0 6px 6px;
                }
            }
            .search{
                position: absolute;
                right: 8%;
                top: 36px;
                .search-icon{
                    cursor: pointer;
                    position: absolute;
                    left: 19px;
                    top: 19px;
                    opacity: 0.6;
                }
                .clear-icon{
                    cursor: pointer;
                    position: absolute;
                    right: 19px;
                    top: 19px;
                    opacity: 0.6;
                }
                .on{
                    width: 530px;
                    height: 28px;
                    background: #FFFFFF;
                    border-radius: 10px;
                    padding: 14px 15px 14px 60px;
                    font-weight: 300;
                    line-height: 18px;
                    color: #333333;
                    transition: width 0.5s;
                }
                .off{
                    width: 120px;
                    height: 28px;
                    background: #FFFFFF;
                    border-radius: 10px;
                    padding: 14px 15px 14px 60px;
                    font-weight: 300;
                    line-height: 18px;
                    color: #333333;
                    transition: width 0.5s;
                }
                input::placeholder{
                    font-weight: 300;
                    line-height: 18px;
                    opacity: 0.6;
                }
            }
        }
		.menu-mobile{
			display: none;
			height: 0;
			width: 0;
		}
		.menu-side{
			// display: none;
			width: 0;
			transition: all 0.6s ease;
		}
    }
	@media only screen and (max-width: 1240px){
		.outer{
			.menu-bottom{
				.icon{
                	top: 0px;
					left: 4%;
					img{
						filter: gray;
						width: 37%;
						height: auto;
						align-self: flex-start;
					}
				}
				.list{
					.top-menu-item{
						margin-right: 8px;
					}
				}
				.search{
					right: 4%;
					.on{
						width: 420px;
					}
					.off{
						width: 100px;
					}
				}
			}
		}
	}
	@media only screen and (max-width: 1024px){
		.outer{
			height: 70px;
			padding: 0 8%;
			.menu-top{
				display: none;
				height: 0;
				width: 0;
			}
			.menu-bottom{
				display: none;
				height: 0;
				width: 0;
			}
			.menu-mobile{
				display: flex;
				flex-direction: row;
				height: 70px;
				.menu-icon{
					margin: auto 0;
				}
				.logo{
					height: 70px;
					img{
						margin: auto 0;
						transform: scale(0.4) translateX(0%) translateY(-60%);
					}
				}
				.menu-lang{
					position: absolute;
					padding-top: 18px;
					right: calc(6% + 90px);
					span{
						line-height: 28px;
						cursor: pointer;
						margin-left: 21px;
						font-weight: 500;
						letter-spacing: 0.04em;
					}
					span.active{
						font-family: Gilroy-Medium;
						color: #4B5F4C;
						font-weight: bold;
					}
					span.imp{
						font-family: Gilroy-Medium;
						font-weight: bold;
					}
				}
				.menu-search{
					position: absolute;
					right: 6%;
					height: 70px;
					padding-top: 24px;
				}
				.menu-impaired{
					position: absolute;
					right: calc(6% + 50px);
					height: 70px;
					padding-top: 24px;
				}
				.search{
					position: absolute;
					right: 6%;
					top: 10px;
					transition: all 0.6s ease;
					.search-icon{
						cursor: pointer;
						position: absolute;
						left: 19px;
						top: 14px;
						opacity: 0.6;
					}
					.clear-icon{
						cursor: pointer;
						position: absolute;
						right: 19px;
						top: 14px;
						opacity: 0.6;
					}
					.on{
						width: 320px;
						height: 28px;
						background: #FFFFFF;
						border-radius: 10px;
						padding: 8px 15px 8px 60px;
						font-weight: 300;
						line-height: 18px;
						color: #333333;
						transition: width 0.5s;
					}
					input::placeholder{
						font-weight: 300;
						line-height: 18px;
						opacity: 0.6;
					}
				}
			}
			.menu-side{
				display: flex;
				position: fixed;
				height: 100%;
				z-index: 999;
				width: 309px;
				left: 0;
				top: 0;
				background: #568357;
				transition: all 0.6s ease;
				overflow-y: scroll;
				.close-icon{
					position: absolute;
					right: 12px;
					top: 26px;
					padding: 6px 8px 0 8px;
				}
				.list{
					margin-top: 60px;
					text-align: left;
					.item{
						cursor: pointer;
						border: 1px solid inherit;
						border-radius: 6px;
						font-weight: 800;
						margin: 5px 15px;
						padding: 10px;
						font-size: 18px;
						line-height: 28px;
						letter-spacing: 0.04em;
						color: #FFFFFF;
					}
					.item.active{	
						border: 1px solid #F0DCC4;
						color: #F0DCC4;
					}
				}
				.phone, .mail{
					text-align: left;
					font-weight: 500;
					font-size: 16px;
					line-height: 26px;
					letter-spacing: 0.05em;
					color: #FFFFFF;
					margin-top: 50px;
					padding: 5px 15px;
				}
				.mail{
					margin-top: 0px;
				}
			}
		}
	}
	@media only screen and (max-width: 720px){
		.outer{
			.menu-mobile{
				.invisible{
					display: none;
				}
				.search{
					position: absolute;
					right: 6%;
					top: 10px;
					transition: all 0.6s ease;
					.search-icon{
						cursor: pointer;
						position: absolute;
						left: 19px;
						top: 14px;
						opacity: 0.6;
					}
					.clear-icon{
						cursor: pointer;
						position: absolute;
						right: 19px;
						top: 14px;
						opacity: 0.6;
					}
					.on{
						width: 180px;
						height: 28px;
						background: #FFFFFF;
						border-radius: 10px;
						padding: 8px 15px 8px 60px;
						font-weight: 300;
						line-height: 18px;
						color: #333333;
						transition: width 0.5s;
					}
					input::placeholder{
						font-weight: 300;
						line-height: 18px;
						opacity: 0.6;
					}
				}
			}
		}
	}
	@media only screen and (max-width: 540px){
		.outer{
			padding: 0 4%;
			.menu-mobile{
				.logo{
					position: absolute;
					left: calc(4% + 0px);
				}
				.menu-search{
					right: 4%;
				}
				.menu-impaired{
					right: calc(4% + 50px);
				}
			}
		}
	}
.dropdown,
.dropleft,
.dropright,
.dropup {
	position: relative
}
.dropdown-toggle {
	white-space: nowrap
}
.dropdown-toggle::after {
	display: inline-block;
	margin-left: .255em;
	vertical-align: .255em;
	content: "";
	border-top: .3em solid;
	border-right: .3em solid transparent;
	border-bottom: 0;
	border-left: .3em solid transparent
}

.dropdown-toggle:empty::after {
	margin-left: 0
}

.dropdown-menu {
	position: absolute;
	top: 100%;
	left: 0;
	z-index: 1000;
	display: none;
	float: left;
	min-width: 10rem;
	padding: .5rem 0;
	margin: .125rem 0 0;
	font-size: 1rem;
	color: #212529;
	text-align: left;
	list-style: none;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, .15);
	border-radius: .25rem
}

.dropdown-menu-left {
	right: auto;
	left: 0
}

.dropdown-menu-right {
	right: 0;
	left: auto
}

@media (min-width:576px) {
	.dropdown-menu-sm-left {
		right: auto;
		left: 0
	}
	.dropdown-menu-sm-right {
		right: 0;
		left: auto
	}
}

@media (min-width:768px) {
	.dropdown-menu-md-left {
		right: auto;
		left: 0
	}
	.dropdown-menu-md-right {
		right: 0;
		left: auto
	}
}

@media (min-width:992px) {
	.dropdown-menu-lg-left {
		right: auto;
		left: 0
	}
	.dropdown-menu-lg-right {
		right: 0;
		left: auto
	}
}

@media (min-width:1200px) {
	.dropdown-menu-xl-left {
		right: auto;
		left: 0
	}
	.dropdown-menu-xl-right {
		right: 0;
		left: auto
	}
}

.dropup .dropdown-menu {
	top: auto;
	bottom: 100%;
	margin-top: 0;
	margin-bottom: .125rem
}

.dropup .dropdown-toggle::after {
	display: inline-block;
	margin-left: .255em;
	vertical-align: .255em;
	content: "";
	border-top: 0;
	border-right: .3em solid transparent;
	border-bottom: .3em solid;
	border-left: .3em solid transparent
}

.dropup .dropdown-toggle:empty::after {
	margin-left: 0
}

.dropright .dropdown-menu {
	top: 0;
	right: auto;
	left: 100%;
	margin-top: 0;
	margin-left: .125rem
}

.dropright .dropdown-toggle::after {
	display: inline-block;
	margin-left: .255em;
	vertical-align: .255em;
	content: "";
	border-top: .3em solid transparent;
	border-right: 0;
	border-bottom: .3em solid transparent;
	border-left: .3em solid
}

.dropright .dropdown-toggle:empty::after {
	margin-left: 0
}

.dropright .dropdown-toggle::after {
	vertical-align: 0
}

.dropleft .dropdown-menu {
	top: 0;
	right: 100%;
	left: auto;
	margin-top: 0;
	margin-right: .125rem
}

.dropleft .dropdown-toggle::after {
	display: inline-block;
	margin-left: .255em;
	vertical-align: .255em;
	content: ""
}

.dropleft .dropdown-toggle::after {
	display: none
}

.dropleft .dropdown-toggle::before {
	display: inline-block;
	margin-right: .255em;
	vertical-align: .255em;
	content: "";
	border-top: .3em solid transparent;
	border-right: .3em solid;
	border-bottom: .3em solid transparent
}

.dropleft .dropdown-toggle:empty::after {
	margin-left: 0
}

.dropleft .dropdown-toggle::before {
	vertical-align: 0
}

.dropdown-menu[x-placement^=bottom],
.dropdown-menu[x-placement^=left],
.dropdown-menu[x-placement^=right],
.dropdown-menu[x-placement^=top] {
	right: auto;
	bottom: auto
}

.dropdown-divider {
	height: 0;
	margin: .5rem 0;
	overflow: hidden;
	border-top: 1px solid #e9ecef
}

.dropdown-item {
	display: block;
	width: 100%;
	padding: .25rem 1.5rem;
	clear: both;
	font-weight: 400;
	color: #212529;
	text-align: inherit;
	white-space: nowrap;
	background-color: transparent;
	border: 0
}

.dropdown-item:focus,
.dropdown-item:hover {
	color: #16181b;
	text-decoration: none;
}

.dropdown-item.active,
.dropdown-item:active {
	color: #fff;
	text-decoration: none;
}

.dropdown-item.disabled,
.dropdown-item:disabled {
	color: #6c757d;
	pointer-events: none;
	background-color: transparent
}

.dropdown-menu.show {
	display: block
}

.dropdown-header {
	display: block;
	padding: .5rem 1.5rem;
	margin-bottom: 0;
	font-size: .875rem;
	color: #6c757d;
	white-space: nowrap
}

.dropdown-item-text {
	display: block;
	padding: .25rem 1.5rem;
	color: #212529
}

.btn-group,
.btn-group-vertical {
	position: relative;
	display: -ms-inline-flexbox;
	display: inline-flex;
	vertical-align: middle
}

.btn-group-vertical>.btn,
.btn-group>.btn {
	position: relative;
	-ms-flex: 1 1 auto;
	flex: 1 1 auto
}

.btn-group-vertical>.btn:hover,
.btn-group>.btn:hover {
	z-index: 1
}

.btn-group-vertical>.btn.active,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn:focus,
.btn-group>.btn.active,
.btn-group>.btn:active,
.btn-group>.btn:focus {
	z-index: 1
}

.btn-toolbar {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	-ms-flex-pack: start;
	justify-content: flex-start
}

.btn-toolbar .input-group {
	width: auto
}

.btn-group>.btn-group:not(:first-child),
.btn-group>.btn:not(:first-child) {
	margin-left: -1px
}

.btn-group>.btn-group:not(:last-child)>.btn,
.btn-group>.btn:not(:last-child):not(.dropdown-toggle) {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0
}

.btn-group>.btn-group:not(:first-child)>.btn,
.btn-group>.btn:not(:first-child) {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0
}

.dropdown-toggle-split {
	padding-right: .5625rem;
	padding-left: .5625rem
}

.dropdown-toggle-split::after,
.dropright .dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after {
	margin-left: 0
}

.dropleft .dropdown-toggle-split::before {
	margin-right: 0
}

.btn-group-sm>.btn+.dropdown-toggle-split,
.btn-sm+.dropdown-toggle-split {
	padding-right: .375rem;
	padding-left: .375rem
}

.btn-group-lg>.btn+.dropdown-toggle-split,
.btn-lg+.dropdown-toggle-split {
	padding-right: .75rem;
	padding-left: .75rem
}

.btn-group-vertical {
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: start;
	align-items: flex-start;
	-ms-flex-pack: center;
	justify-content: center
}

.btn-group-vertical>.btn,
.btn-group-vertical>.btn-group {
	width: 100%
}

.btn-group-vertical>.btn-group:not(:first-child),
.btn-group-vertical>.btn:not(:first-child) {
	margin-top: -1px
}

.btn-group-vertical>.btn-group:not(:last-child)>.btn,
.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle) {
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0
}

.btn-group-vertical>.btn-group:not(:first-child)>.btn,
.btn-group-vertical>.btn:not(:first-child) {
	border-top-left-radius: 0;
	border-top-right-radius: 0
}

.btn-group-toggle>.btn,
.btn-group-toggle>.btn-group>.btn {
	margin-bottom: 0
}

.btn-group-toggle>.btn input[type=checkbox],
.btn-group-toggle>.btn input[type=radio],
.btn-group-toggle>.btn-group>.btn input[type=checkbox],
.btn-group-toggle>.btn-group>.btn input[type=radio] {
	position: absolute;
	clip: rect(0, 0, 0, 0);
	pointer-events: none
}

.input-group {
	position: relative;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	-ms-flex-align: stretch;
	align-items: stretch;
	width: 100%
}

.input-group>.custom-file,
.input-group>.custom-select,
.input-group>.form-control,
.input-group>.form-control-plaintext {
	position: relative;
	-ms-flex: 1 1 auto;
	flex: 1 1 auto;
	width: 1%;
	min-width: 0;
	margin-bottom: 0
}

.input-group>.custom-file+.custom-file,
.input-group>.custom-file+.custom-select,
.input-group>.custom-file+.form-control,
.input-group>.custom-select+.custom-file,
.input-group>.custom-select+.custom-select,
.input-group>.custom-select+.form-control,
.input-group>.form-control+.custom-file,
.input-group>.form-control+.custom-select,
.input-group>.form-control+.form-control,
.input-group>.form-control-plaintext+.custom-file,
.input-group>.form-control-plaintext+.custom-select,
.input-group>.form-control-plaintext+.form-control {
	margin-left: -1px
}

.input-group>.custom-file .custom-file-input:focus~.custom-file-label,
.input-group>.custom-select:focus,
.input-group>.form-control:focus {
	z-index: 3
}

.input-group>.custom-file .custom-file-input:focus {
	z-index: 4
}

.input-group>.custom-select:not(:last-child),
.input-group>.form-control:not(:last-child) {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0
}

.input-group>.custom-select:not(:first-child),
.input-group>.form-control:not(:first-child) {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0
}

.input-group>.custom-file {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-align: center;
	align-items: center
}

.input-group>.custom-file:not(:last-child) .custom-file-label,
.input-group>.custom-file:not(:last-child) .custom-file-label::after {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0
}

.input-group>.custom-file:not(:first-child) .custom-file-label {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0
}

.input-group-append,
.input-group-prepend {
	display: -ms-flexbox;
	display: flex
}

.input-group-append .btn,
.input-group-prepend .btn {
	position: relative;
	z-index: 2
}

.input-group-append .btn:focus,
.input-group-prepend .btn:focus {
	z-index: 3
}

.input-group-append .btn+.btn,
.input-group-append .btn+.input-group-text,
.input-group-append .input-group-text+.btn,
.input-group-append .input-group-text+.input-group-text,
.input-group-prepend .btn+.btn,
.input-group-prepend .btn+.input-group-text,
.input-group-prepend .input-group-text+.btn,
.input-group-prepend .input-group-text+.input-group-text {
	margin-left: -1px
}

.input-group-prepend {
	margin-right: -1px
}

.input-group-append {
	margin-left: -1px
}

.input-group-text {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-align: center;
	align-items: center;
	padding: .375rem .75rem;
	margin-bottom: 0;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	text-align: center;
	white-space: nowrap;
	background-color: #e9ecef;
	border: 1px solid #ced4da;
	border-radius: .25rem
}

.input-group-text input[type=checkbox],
.input-group-text input[type=radio] {
	margin-top: 0
}

.input-group-lg>.custom-select,
.input-group-lg>.form-control:not(textarea) {
	height: calc(1.5em + 1rem + 2px)
}

.input-group-lg>.custom-select,
.input-group-lg>.form-control,
.input-group-lg>.input-group-append>.btn,
.input-group-lg>.input-group-append>.input-group-text,
.input-group-lg>.input-group-prepend>.btn,
.input-group-lg>.input-group-prepend>.input-group-text {
	padding: .5rem 1rem;
	font-size: 1.25rem;
	line-height: 1.5;
	border-radius: .3rem
}

.input-group-sm>.custom-select,
.input-group-sm>.form-control:not(textarea) {
	height: calc(1.5em + .5rem + 2px)
}

.input-group-sm>.custom-select,
.input-group-sm>.form-control,
.input-group-sm>.input-group-append>.btn,
.input-group-sm>.input-group-append>.input-group-text,
.input-group-sm>.input-group-prepend>.btn,
.input-group-sm>.input-group-prepend>.input-group-text {
	padding: .25rem .5rem;
	font-size: .875rem;
	line-height: 1.5;
	border-radius: .2rem
}

.input-group-lg>.custom-select,
.input-group-sm>.custom-select {
	padding-right: 1.75rem
}

.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),
.input-group>.input-group-append:not(:last-child)>.btn,
.input-group>.input-group-append:not(:last-child)>.input-group-text,
.input-group>.input-group-prepend>.btn,
.input-group>.input-group-prepend>.input-group-text {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0
}

.input-group>.input-group-append>.btn,
.input-group>.input-group-append>.input-group-text,
.input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),
.input-group>.input-group-prepend:not(:first-child)>.btn,
.input-group>.input-group-prepend:not(:first-child)>.input-group-text {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0
}

.custom-control {
	position: relative;
	display: block;
	min-height: 1.5rem;
	padding-left: 1.5rem
}

.custom-control-inline {
	display: -ms-inline-flexbox;
	display: inline-flex;
	margin-right: 1rem
}

.custom-control-input {
	position: absolute;
	left: 0;
	z-index: -1;
	width: 1rem;
	height: 1.25rem;
	opacity: 0
}

.custom-control-input:checked~.custom-control-label::before {
	color: #fff;
	border-color: #007bff;
	background-color: #007bff
}

.custom-control-input:focus~.custom-control-label::before {
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-control-input:focus:not(:checked)~.custom-control-label::before {
	border-color: #80bdff
}

.custom-control-input:not(:disabled):active~.custom-control-label::before {
	color: #fff;
	background-color: #b3d7ff;
	border-color: #b3d7ff
}

.custom-control-input:disabled~.custom-control-label,
.custom-control-input[disabled]~.custom-control-label {
	color: #6c757d
}

.custom-control-input:disabled~.custom-control-label::before,
.custom-control-input[disabled]~.custom-control-label::before {
	background-color: #e9ecef
}

.custom-control-label {
	position: relative;
	margin-bottom: 0;
	vertical-align: top
}

.custom-control-label::before {
	position: absolute;
	top: .25rem;
	left: -1.5rem;
	display: block;
	width: 1rem;
	height: 1rem;
	pointer-events: none;
	content: "";
	background-color: #fff;
	border: #adb5bd solid 1px
}

.custom-control-label::after {
	position: absolute;
	top: .25rem;
	left: -1.5rem;
	display: block;
	width: 1rem;
	height: 1rem;
	content: "";
	background: no-repeat 50%/50% 50%
}

.custom-checkbox .custom-control-label::before {
	border-radius: .25rem
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
	background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e")
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {
	border-color: #007bff;
	background-color: #007bff
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {
	background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e")
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
	background-color: rgba(0, 123, 255, .5)
}

.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {
	background-color: rgba(0, 123, 255, .5)
}

.custom-radio .custom-control-label::before {
	border-radius: 50%
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
	background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e")
}

.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {
	background-color: rgba(0, 123, 255, .5)
}

.custom-switch {
	padding-left: 2.25rem
}

.custom-switch .custom-control-label::before {
	left: -2.25rem;
	width: 1.75rem;
	pointer-events: all;
	border-radius: .5rem
}

.custom-switch .custom-control-label::after {
	top: calc(.25rem + 2px);
	left: calc(-2.25rem + 2px);
	width: calc(1rem - 4px);
	height: calc(1rem - 4px);
	background-color: #adb5bd;
	border-radius: .5rem;
	transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-transform .15s ease-in-out;
	transition: transform .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	transition: transform .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-transform .15s ease-in-out
}

@media (prefers-reduced-motion:reduce) {
	.custom-switch .custom-control-label::after {
		transition: none
	}
}

.custom-switch .custom-control-input:checked~.custom-control-label::after {
	background-color: #fff;
	-webkit-transform: translateX(.75rem);
	transform: translateX(.75rem)
}

.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before {
	background-color: rgba(0, 123, 255, .5)
}

.custom-select {
	display: inline-block;
	width: 100%;
	height: calc(1.5em + .75rem + 2px);
	padding: .375rem 1.75rem .375rem .75rem;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	vertical-align: middle;
	background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px;
	border: 1px solid #ced4da;
	border-radius: .25rem;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none
}

.custom-select:focus {
	border-color: #80bdff;
	outline: 0;
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-select:focus::-ms-value {
	color: #495057;
	background-color: #fff
}

.custom-select[multiple],
.custom-select[size]:not([size="1"]) {
	height: auto;
	padding-right: .75rem;
	background-image: none
}

.custom-select:disabled {
	color: #6c757d;
	background-color: #e9ecef
}

.custom-select::-ms-expand {
	display: none
}

.custom-select:-moz-focusring {
	color: transparent;
	text-shadow: 0 0 0 #495057
}

.custom-select-sm {
	height: calc(1.5em + .5rem + 2px);
	padding-top: .25rem;
	padding-bottom: .25rem;
	padding-left: .5rem;
	font-size: .875rem
}

.custom-select-lg {
	height: calc(1.5em + 1rem + 2px);
	padding-top: .5rem;
	padding-bottom: .5rem;
	padding-left: 1rem;
	font-size: 1.25rem
}

.custom-file {
	position: relative;
	display: inline-block;
	width: 100%;
	height: calc(1.5em + .75rem + 2px);
	margin-bottom: 0
}

.custom-file-input {
	position: relative;
	z-index: 2;
	width: 100%;
	height: calc(1.5em + .75rem + 2px);
	margin: 0;
	opacity: 0
}

.custom-file-input:focus~.custom-file-label {
	border-color: #80bdff;
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-file-input:disabled~.custom-file-label,
.custom-file-input[disabled]~.custom-file-label {
	background-color: #e9ecef
}

.custom-file-input:lang(en)~.custom-file-label::after {
	content: "Browse"
}

.custom-file-input~.custom-file-label[data-browse]::after {
	content: attr(data-browse)
}

.custom-file-label {
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	z-index: 1;
	height: calc(1.5em + .75rem + 2px);
	padding: .375rem .75rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	background-color: #fff;
	border: 1px solid #ced4da;
	border-radius: .25rem
}

.custom-file-label::after {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 3;
	display: block;
	height: calc(1.5em + .75rem);
	padding: .375rem .75rem;
	line-height: 1.5;
	color: #495057;
	content: "Browse";
	background-color: #e9ecef;
	border-left: inherit;
	border-radius: 0 .25rem .25rem 0
}

.custom-range {
	width: 100%;
	height: 1.4rem;
	padding: 0;
	background-color: transparent;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none
}

.custom-range:focus {
	outline: 0
}

.custom-range:focus::-webkit-slider-thumb {
	box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-range:focus::-moz-range-thumb {
	box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-range:focus::-ms-thumb {
	box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-range::-moz-focus-outer {
	border: 0
}

.custom-range::-webkit-slider-thumb {
	width: 1rem;
	height: 1rem;
	margin-top: -.25rem;
	background-color: #007bff;
	border: 0;
	border-radius: 1rem;
	-webkit-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	-webkit-appearance: none;
	appearance: none
}

@media (prefers-reduced-motion:reduce) {
	.custom-range::-webkit-slider-thumb {
		-webkit-transition: none;
		transition: none
	}
}

.custom-range::-webkit-slider-thumb:active {
	background-color: #b3d7ff
}

.custom-range::-webkit-slider-runnable-track {
	width: 100%;
	height: .5rem;
	color: transparent;
	cursor: pointer;
	background-color: #dee2e6;
	border-color: transparent;
	border-radius: 1rem
}

.custom-range::-moz-range-thumb {
	width: 1rem;
	height: 1rem;
	background-color: #007bff;
	border: 0;
	border-radius: 1rem;
	-moz-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	-moz-appearance: none;
	appearance: none
}

@media (prefers-reduced-motion:reduce) {
	.custom-range::-moz-range-thumb {
		-moz-transition: none;
		transition: none
	}
}

.custom-range::-moz-range-thumb:active {
	background-color: #b3d7ff
}

.custom-range::-moz-range-track {
	width: 100%;
	height: .5rem;
	color: transparent;
	cursor: pointer;
	background-color: #dee2e6;
	border-color: transparent;
	border-radius: 1rem
}

.custom-range::-ms-thumb {
	width: 1rem;
	height: 1rem;
	margin-top: 0;
	margin-right: .2rem;
	margin-left: .2rem;
	background-color: #007bff;
	border: 0;
	border-radius: 1rem;
	-ms-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	appearance: none
}

@media (prefers-reduced-motion:reduce) {
	.custom-range::-ms-thumb {
		-ms-transition: none;
		transition: none
	}
}

.custom-range::-ms-thumb:active {
	background-color: #b3d7ff
}

.custom-range::-ms-track {
	width: 100%;
	height: .5rem;
	color: transparent;
	cursor: pointer;
	background-color: transparent;
	border-color: transparent;
	border-width: .5rem
}

.custom-range::-ms-fill-lower {
	background-color: #dee2e6;
	border-radius: 1rem
}

.custom-range::-ms-fill-upper {
	margin-right: 15px;
	background-color: #dee2e6;
	border-radius: 1rem
}

.custom-range:disabled::-webkit-slider-thumb {
	background-color: #adb5bd
}

.custom-range:disabled::-webkit-slider-runnable-track {
	cursor: default
}

.custom-range:disabled::-moz-range-thumb {
	background-color: #adb5bd
}

.custom-range:disabled::-moz-range-track {
	cursor: default
}

.custom-range:disabled::-ms-thumb {
	background-color: #adb5bd
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
	transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion:reduce) {
	.custom-control-label::before,
	.custom-file-label,
	.custom-select {
		transition: none
	}
}

.nav {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	padding-left: 0;
	margin-bottom: 0;
	list-style: none
}

.nav-link {
	display: block;
	padding: .5rem 1rem
}

.nav-link:focus,
.nav-link:hover {
	text-decoration: none
}

.nav-link.disabled {
	color: #6c757d;
	pointer-events: none;
	cursor: default
}

.nav-tabs {
	border-bottom: 1px solid #dee2e6
}

.nav-tabs .nav-item {
	margin-bottom: -1px
}

.nav-tabs .nav-link {
	border: 1px solid transparent;
	border-top-left-radius: .25rem;
	border-top-right-radius: .25rem
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
	border-color: #e9ecef #e9ecef #dee2e6
}

.nav-tabs .nav-link.disabled {
	color: #6c757d;
	background-color: transparent;
	border-color: transparent
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
	color: #495057;
	background-color: #fff;
	border-color: #dee2e6 #dee2e6 #fff
}

.nav-tabs .dropdown-menu {
	margin-top: -1px;
	border-top-left-radius: 0;
	border-top-right-radius: 0
}

.nav-pills .nav-link {
	border-radius: .25rem
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
	color: #fff;
	background-color: #007bff
}

.nav-fill .nav-item {
	-ms-flex: 1 1 auto;
	flex: 1 1 auto;
	text-align: center
}

.nav-justified .nav-item {
	-ms-flex-preferred-size: 0;
	flex-basis: 0;
	-ms-flex-positive: 1;
	flex-grow: 1;
	text-align: center
}

.tab-content>.tab-pane {
	display: none
}

.tab-content>.active {
	display: block
}

.navbar {
	position: relative;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	-ms-flex-align: center;
	align-items: center;
	-ms-flex-pack: justify;
	justify-content: space-between;
	padding: .5rem 1rem
}

.navbar .container,
.navbar .container-fluid,
.navbar .container-lg,
.navbar .container-md,
.navbar .container-sm,
.navbar .container-xl {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	-ms-flex-align: center;
	align-items: center;
	-ms-flex-pack: justify;
	justify-content: space-between
}

.navbar-brand {
	display: inline-block;
	padding-top: .3125rem;
	padding-bottom: .3125rem;
	margin-right: 1rem;
	font-size: 1.25rem;
	line-height: inherit;
	white-space: nowrap
}

.navbar-brand:focus,
.navbar-brand:hover {
	text-decoration: none
}

.navbar-nav {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	padding-left: 0;
	margin-bottom: 0;
	list-style: none
}

.navbar-nav .nav-link {
	padding-right: 0;
	padding-left: 0
}

.navbar-nav .dropdown-menu {
	position: static;
	float: none
}

.navbar-text {
	display: inline-block;
	padding-top: .5rem;
	padding-bottom: .5rem
}

.navbar-collapse {
	-ms-flex-preferred-size: 100%;
	flex-basis: 100%;
	-ms-flex-positive: 1;
	flex-grow: 1;
	-ms-flex-align: center;
	align-items: center
}

.navbar-toggler {
	padding: .25rem .75rem;
	font-size: 1.25rem;
	line-height: 1;
	background-color: transparent;
	border: 1px solid transparent;
	border-radius: .25rem
}

.navbar-toggler:focus,
.navbar-toggler:hover {
	text-decoration: none
}

.navbar-toggler-icon {
	display: inline-block;
	width: 1.5em;
	height: 1.5em;
	vertical-align: middle;
	content: "";
	background: no-repeat center center;
	background-size: 100% 100%
}

@media (max-width:575.98px) {
	.navbar-expand-sm>.container,
	.navbar-expand-sm>.container-fluid,
	.navbar-expand-sm>.container-lg,
	.navbar-expand-sm>.container-md,
	.navbar-expand-sm>.container-sm,
	.navbar-expand-sm>.container-xl {
		padding-right: 0;
		padding-left: 0
	}
}

@media (min-width:576px) {
	.navbar-expand-sm {
		-ms-flex-flow: row nowrap;
		flex-flow: row nowrap;
		-ms-flex-pack: start;
		justify-content: flex-start
	}
	.navbar-expand-sm .navbar-nav {
		-ms-flex-direction: row;
		flex-direction: row
	}
	.navbar-expand-sm .navbar-nav .dropdown-menu {
		position: absolute
	}
	.navbar-expand-sm .navbar-nav .nav-link {
		padding-right: .5rem;
		padding-left: .5rem
	}
	.navbar-expand-sm>.container,
	.navbar-expand-sm>.container-fluid,
	.navbar-expand-sm>.container-lg,
	.navbar-expand-sm>.container-md,
	.navbar-expand-sm>.container-sm,
	.navbar-expand-sm>.container-xl {
		-ms-flex-wrap: nowrap;
		flex-wrap: nowrap
	}
	.navbar-expand-sm .navbar-collapse {
		display: -ms-flexbox!important;
		display: flex!important;
		-ms-flex-preferred-size: auto;
		flex-basis: auto
	}
	.navbar-expand-sm .navbar-toggler {
		display: none
	}
}

@media (max-width:767.98px) {
	.navbar-expand-md>.container,
	.navbar-expand-md>.container-fluid,
	.navbar-expand-md>.container-lg,
	.navbar-expand-md>.container-md,
	.navbar-expand-md>.container-sm,
	.navbar-expand-md>.container-xl {
		padding-right: 0;
		padding-left: 0
	}
}

@media (min-width:768px) {
	.navbar-expand-md {
		-ms-flex-flow: row nowrap;
		flex-flow: row nowrap;
		-ms-flex-pack: start;
		justify-content: flex-start
	}
	.navbar-expand-md .navbar-nav {
		-ms-flex-direction: row;
		flex-direction: row
	}
	.navbar-expand-md .navbar-nav .dropdown-menu {
		position: absolute
	}
	.navbar-expand-md .navbar-nav .nav-link {
		padding-right: .5rem;
		padding-left: .5rem
	}
	.navbar-expand-md>.container,
	.navbar-expand-md>.container-fluid,
	.navbar-expand-md>.container-lg,
	.navbar-expand-md>.container-md,
	.navbar-expand-md>.container-sm,
	.navbar-expand-md>.container-xl {
		-ms-flex-wrap: nowrap;
		flex-wrap: nowrap
	}
	.navbar-expand-md .navbar-collapse {
		display: -ms-flexbox!important;
		display: flex!important;
		-ms-flex-preferred-size: auto;
		flex-basis: auto
	}
	.navbar-expand-md .navbar-toggler {
		display: none
	}
}

@media (max-width:991.98px) {
	.navbar-expand-lg>.container,
	.navbar-expand-lg>.container-fluid,
	.navbar-expand-lg>.container-lg,
	.navbar-expand-lg>.container-md,
	.navbar-expand-lg>.container-sm,
	.navbar-expand-lg>.container-xl {
		padding-right: 0;
		padding-left: 0
	}
}

@media (min-width:992px) {
	.navbar-expand-lg {
		-ms-flex-flow: row nowrap;
		flex-flow: row nowrap;
		-ms-flex-pack: start;
		justify-content: flex-start
	}
	.navbar-expand-lg .navbar-nav {
		-ms-flex-direction: row;
		flex-direction: row
	}
	.navbar-expand-lg .navbar-nav .dropdown-menu {
		position: absolute
	}
	.navbar-expand-lg .navbar-nav .nav-link {
		padding-right: .5rem;
		padding-left: .5rem
	}
	.navbar-expand-lg>.container,
	.navbar-expand-lg>.container-fluid,
	.navbar-expand-lg>.container-lg,
	.navbar-expand-lg>.container-md,
	.navbar-expand-lg>.container-sm,
	.navbar-expand-lg>.container-xl {
		-ms-flex-wrap: nowrap;
		flex-wrap: nowrap
	}
	.navbar-expand-lg .navbar-collapse {
		display: -ms-flexbox!important;
		display: flex!important;
		-ms-flex-preferred-size: auto;
		flex-basis: auto
	}
	.navbar-expand-lg .navbar-toggler {
		display: none
	}
}

@media (max-width:1199.98px) {
	.navbar-expand-xl>.container,
	.navbar-expand-xl>.container-fluid,
	.navbar-expand-xl>.container-lg,
	.navbar-expand-xl>.container-md,
	.navbar-expand-xl>.container-sm,
	.navbar-expand-xl>.container-xl {
		padding-right: 0;
		padding-left: 0
	}
}

@media (min-width:1200px) {
	.navbar-expand-xl {
		-ms-flex-flow: row nowrap;
		flex-flow: row nowrap;
		-ms-flex-pack: start;
		justify-content: flex-start
	}
	.navbar-expand-xl .navbar-nav {
		-ms-flex-direction: row;
		flex-direction: row
	}
	.navbar-expand-xl .navbar-nav .dropdown-menu {
		position: absolute
	}
	.navbar-expand-xl .navbar-nav .nav-link {
		padding-right: .5rem;
		padding-left: .5rem
	}
	.navbar-expand-xl>.container,
	.navbar-expand-xl>.container-fluid,
	.navbar-expand-xl>.container-lg,
	.navbar-expand-xl>.container-md,
	.navbar-expand-xl>.container-sm,
	.navbar-expand-xl>.container-xl {
		-ms-flex-wrap: nowrap;
		flex-wrap: nowrap
	}
	.navbar-expand-xl .navbar-collapse {
		display: -ms-flexbox!important;
		display: flex!important;
		-ms-flex-preferred-size: auto;
		flex-basis: auto
	}
	.navbar-expand-xl .navbar-toggler {
		display: none
	}
}

.navbar-expand {
	-ms-flex-flow: row nowrap;
	flex-flow: row nowrap;
	-ms-flex-pack: start;
	justify-content: flex-start
}

.navbar-expand>.container,
.navbar-expand>.container-fluid,
.navbar-expand>.container-lg,
.navbar-expand>.container-md,
.navbar-expand>.container-sm,
.navbar-expand>.container-xl {
	padding-right: 0;
	padding-left: 0
}

.navbar-expand .navbar-nav {
	-ms-flex-direction: row;
	flex-direction: row
}

.navbar-expand .navbar-nav .dropdown-menu {
	position: absolute
}



/*# sourceMappingURL=bootstrap.min.css.map */
</style>


